import logger from "@ane/core/lib/services/logging/Logger";
import ___default from "lodash";
import { ofType, combineEpics } from "redux-observable";
import { tap, ignoreElements, filter, map } from "rxjs/operators";
import { setStepPropertiesLoad, setPlanSummaryLoad, setAutoShutdownLoad, setAlertsLoad, setAnalysesLoad, setScorecardsLoad, setHypothesisLoad, setSlicesLoad, setWarningsLoad, setMetricCategoriesLoad, setScorecardDataLoad, fullLoad, mainFunctionalityLoad } from "./GarLogPerformanceActions.js";
import GarLogPerformanceConstants from "./GarLogPerformanceConstants.js";
const loadStart = (action$) => {
  return action$.pipe(
    ofType(GarLogPerformanceConstants.LOAD_START),
    tap((action) => logger.trackMetric({ average: action.payload.clientTimeInMs, name: `PLT:${action.type}`, properties: {} })),
    // ignoreElements: This epic only needs to log LOAD_START, so we don't need to pipe any additional actions
    ignoreElements()
  );
};
const mapCheckMarkToStoreAndAction = {
  [GarLogPerformanceConstants.CHECK_STEP_PROPERTIES]: {
    storeName: "stepPropertiesLoadTime",
    setAction: setStepPropertiesLoad
  },
  [GarLogPerformanceConstants.CHECK_PLAN_SUMMARY]: {
    storeName: "planSummaryLoadTime",
    setAction: setPlanSummaryLoad
  },
  [GarLogPerformanceConstants.CHECK_AUTOSHUTDOWN]: {
    storeName: "autoShutdownLoadTime",
    setAction: setAutoShutdownLoad
  },
  [GarLogPerformanceConstants.CHECK_ALERTS]: {
    storeName: "alertsLoadTime",
    setAction: setAlertsLoad
  },
  [GarLogPerformanceConstants.CHECK_ANALYSES]: {
    storeName: "analysesLoadTime",
    setAction: setAnalysesLoad
  },
  [GarLogPerformanceConstants.CHECK_SCORECARDS]: {
    storeName: "scorecardsLoadTime",
    setAction: setScorecardsLoad
  },
  [GarLogPerformanceConstants.CHECK_HYPOTHESIS]: {
    storeName: "hypothesisLoadTime",
    setAction: setHypothesisLoad
  },
  [GarLogPerformanceConstants.CHECK_SLICES]: {
    storeName: "slicesLoadTime",
    setAction: setSlicesLoad
  },
  [GarLogPerformanceConstants.CHECK_WARNINGS]: {
    storeName: "warningsLoadTime",
    setAction: setWarningsLoad
  },
  [GarLogPerformanceConstants.CHECK_METRIC_CATEGORIES]: {
    storeName: "metricCategoriesLoadTime",
    setAction: setMetricCategoriesLoad
  },
  [GarLogPerformanceConstants.CHECK_SCORECARD_DATA]: {
    storeName: "scorecardDataLoadTime",
    setAction: setScorecardDataLoad
  }
};
const checkActions = ___default.keys(mapCheckMarkToStoreAndAction);
const checkStoreForPltMark = (action$, state$) => {
  return action$.pipe(
    ofType(...checkActions),
    filter((action) => {
      const config = mapCheckMarkToStoreAndAction[action.type];
      if (!config) {
        throw new Error(`action not supported in checkStoreForPltMark: ${action.type}`);
      }
      return state$.value.gar.GARPerformance[config.storeName] === null || action.payload.warm == true;
    }),
    map((action) => {
      const config = mapCheckMarkToStoreAndAction[action.type];
      if (action.payload.warm == true) {
        const existingTime = state$.value.gar.GARPerformance[config.storeName].timeSinceLoadStartInMs;
        return config.setAction(existingTime, action.payload.warm);
      }
      const loadStartTimeInMs = state$.value.gar.GARPerformance.pageLoadClientTime || 0;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `GarPLT:${action.type}`,
        properties: { timeSinceLoadStartInMs, loadStartTimeInMs }
      });
      return config.setAction(action.payload.clientTimeInMs, action.payload.warm);
    })
  );
};
const basePerformanceComplete = (state$) => {
  return !!state$.value.gar.GARPerformance.analysesLoadTime && !!state$.value.gar.GARPerformance.autoShutdownLoadTime && !!state$.value.gar.GARPerformance.hypothesisLoadTime && !!state$.value.gar.GARPerformance.metricCategoriesLoadTime && !!state$.value.gar.GARPerformance.pageLoadClientTime && !!state$.value.gar.GARPerformance.planSummaryLoadTime && !!state$.value.gar.GARPerformance.scorecardsLoadTime && !!state$.value.gar.GARPerformance.slicesLoadTime && !!state$.value.gar.GARPerformance.stepPropertiesLoadTime && !!state$.value.gar.GARPerformance.warningsLoadTime && !!state$.value.gar.GARPerformance.mainFunctionality;
};
const shouldSetMainFunctionality = (state$) => {
  return basePerformanceComplete(state$) && state$.value.gar.GARPerformance.mainFunctionalityLoad === null;
};
const shouldSetFullLoad = (state$) => {
  return basePerformanceComplete(state$) && !!state$.value.gar.GARPerformance.scorecardDataLoadTime && state$.value.gar.GARPerformance.fullLoad === null;
};
const isWarmLoad = (state$) => {
  var isWarmLoad2 = true;
  if (!!state$.value.gar.GARPerformance.analysesLoadTime && state$.value.gar.GARPerformance.analysesLoadTime.warm == false && !!state$.value.gar.GARPerformance.autoShutdownLoadTime && state$.value.gar.GARPerformance.autoShutdownLoadTime.warm == false && !!state$.value.gar.GARPerformance.hypothesisLoadTime && state$.value.gar.GARPerformance.hypothesisLoadTime.warm == false && !!state$.value.gar.GARPerformance.metricCategoriesLoadTime && state$.value.gar.GARPerformance.metricCategoriesLoadTime.warm == false && !!state$.value.gar.GARPerformance.pageLoadClientTime && !!state$.value.gar.GARPerformance.planSummaryLoadTime && state$.value.gar.GARPerformance.planSummaryLoadTime.warm == false && (state$.value.gar.GARPerformance.scorecardDataLoadTime == null || !!state$.value.gar.GARPerformance.scorecardDataLoadTime && state$.value.gar.GARPerformance.scorecardDataLoadTime.warm == false) && !!state$.value.gar.GARPerformance.scorecardsLoadTime && state$.value.gar.GARPerformance.scorecardsLoadTime.warm == false && !!state$.value.gar.GARPerformance.slicesLoadTime && state$.value.gar.GARPerformance.slicesLoadTime.warm == false && !!state$.value.gar.GARPerformance.stepPropertiesLoadTime && state$.value.gar.GARPerformance.stepPropertiesLoadTime.warm == false && !!state$.value.gar.GARPerformance.warningsLoadTime && state$.value.gar.GARPerformance.warningsLoadTime.warm == false && !!state$.value.gar.GARPerformance.mainFunctionality && state$.value.gar.GARPerformance.mainFunctionality.warm == false && state$.value.gar.GARPerformance.fullLoad === null) {
    isWarmLoad2 = false;
  }
  return isWarmLoad2;
};
const mainFunctionality = (action$, state$) => {
  return action$.pipe(
    ofType(GarLogPerformanceConstants.MAIN_FUNCTIONALITY),
    filter(() => {
      return shouldSetMainFunctionality(state$) || shouldSetFullLoad(state$);
    }),
    tap((action) => {
      const loadStartTimeInMs = state$.value.gar.GARPerformance.pageLoadClientTime || 0;
      const loadTime = action.payload.clientTimeInMs;
      const actionWarmName = isWarmLoad(state$) ? "warm:" : "";
      const actionName = shouldSetFullLoad(state$) ? "FULL_LOAD" : action.type;
      logger.trackMetric({
        average: loadTime,
        name: `GarPLT:${actionWarmName}${actionName}`,
        properties: { loadTime, loadStartTimeInMs }
      });
    }),
    // if ALL MFL values are sent then emit MAIN_FUNCTIONALITY
    map((action) => {
      var _a, _b, _c, _d;
      return shouldSetFullLoad(state$) ? fullLoad(
        // using MAIN_FUNCTIONALITY again causes an infinite loop
        action.payload.clientTimeInMs,
        (_b = (_a = state$.value.gar.GARPerformance.mainFunctionality) == null ? void 0 : _a.lastPartToLoad) != null ? _b : action.type,
        isWarmLoad(state$)
      ) : mainFunctionalityLoad(
        // using MAIN_FUNCTIONALITY again causes an infinite loop
        action.payload.clientTimeInMs,
        (_d = (_c = state$.value.gar.GARPerformance.mainFunctionality) == null ? void 0 : _c.lastPartToLoad) != null ? _d : action.type,
        isWarmLoad(state$)
      );
    })
  );
};
const garLogPerformanceEpics = combineEpics(loadStart, checkStoreForPltMark, mainFunctionality);
export {
  basePerformanceComplete,
  checkStoreForPltMark,
  garLogPerformanceEpics,
  isWarmLoad,
  loadStart,
  mainFunctionality,
  shouldSetFullLoad,
  shouldSetMainFunctionality
};
//# sourceMappingURL=GarLogPerformanceEpics.js.map
